var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"el-icon-caret-bottom",style:(`color: ${_vm.directionSort === 'DESC' ? '#1e88e5' : '#BDBDBD'}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }